var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000001354(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24.3999,
    height: 24.3999,
    rx: 1,
    fill: "#154063",
    stroke: "#154063",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2,
    y: 5,
    width: 2.39999,
    height: 17.2799,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15.0798,
    width: 2.39999,
    height: 17.2799,
    transform: "rotate(-90 5 15.0798)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000001354);
export default __webpack_public_path__ + "static/media/Group 1000001354.ab45e19ea1dea8ac93071f1f4dd4763b.svg";
export { ForwardRef as ReactComponent };